module.exports = __webpack_public_path__ + "about_us_header.abefa6aa35ad318050f9.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/about_us_header.png
// module id = ../../../../../src/assets/img/about_us_header.png
// module chunks = styles